import { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table, Input, Alert } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'
import TextInput from '../TextInput'
import YesNoSelect from '../YesNoSelect'

export default function LossSettlementForm({ location }) {
  console.log('LossSettlementForm rendered: ', location)
  const pathname = location.pathname.split('/')[2]

  let init = {
    firstName: '',
    lastName: '',
    dobFrom: '',
    dobTo: '',
    plaintiffStatus: [],
    currentDiagnosis: [],
    plaintiffCounsel: [],
    defenseCounsel: [],
    firmType: [],
    state: [],
    courtType: [],
    exposureType: [],
    validReopen: [],
    arpcForecast: [],
    groupId: '',
    dateAssignedFrom: '',
    dateAssignedTo: '',
    dateClosedFrom: '',
    dateClosedTo: '',
    settlementDateFrom: '',
    settlementDateTo: '',
    nextPaymentDueDateFrom: '',
    nextPaymentDueDateTo: '',
    dateReopenedFrom: '',
    dateReopenedTo: '',
    DateReclosedFrom: '',
    DateReclosedTo: '',
    dateMovedToPendingFrom: '',
    dateMovedToPendingTo: '',
    dateMovedToAbandonedFrom: '',
    dateMovedToAbandonedTo: '',
    dateMovedToInactiveFrom: '',
    dateMovedToInactiveTo: '',
    dateMovedToOpenFrom: '',
    dateMovedToOpenTo: '',
    dateMovedToClosedFrom: '',
    dateMovedToClosedTo: '',
    dateMovedFromInactiveFrom: '',
    dateMovedFromInactiveTo: '',
    amountOperator: '',
    settlementAmount: '',
    includeBlankSettlementAmounts: '',
    settlementType: '1',
    checkNumber: '',
    documentId: '',
    sortBy: 'BY_PLAINTIFF_LAST_NAME',
    normalized: ''
  }

  const navigate = useNavigate()
  init = initialFormValues(`${pathname}`, navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))
  const [formFeedback, setFormFeedback] = useState({})



  // Scroll error messages into view
  const scrollRef = useRef(null)
  useEffect(() => {
    console.log('userEffect: ', formFeedback, scrollRef)
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView()
    }
  }, [formFeedback])
  // ------------------------------

  async function submitSearch() {
    console.log('LossSettlementForm.submitSearch', inputs)

    inputs.includeBlankSettlementAmounts = inputs.includeBlankSettlementAmounts === 'on' ? 'Y' : ''
    let validSettlementInput = true
    let validPaymentInput = true
    let validInput = false
    // eslint-disable-next-line eqeqeq
    if ((inputs.settlementType == 3 && !inputs.settlementDateFrom) && (inputs.settlementType == 3 && !inputs.settlementDateTo)) {
      validSettlementInput = false
    }
    // eslint-disable-next-line eqeqeq
    if ((inputs.settlementType == 4 && !inputs.nextPaymentDueDateFrom) && (inputs.settlementType == 4 && !inputs.nextPaymentDueDateTo)) {
      validPaymentInput = false
    }

    for (let input in inputs) {
      if ((input !== 'sortBy' &&
        input !== 'settlementType' &&
        input !== 'amountOperator' &&
        input !== 'includeBlankSettlementAmounts' &&
        input !== 'settlementAmount') && inputs[input]) {
        if (inputs[input].length && inputs[input].length > 0) {
          console.log(input)
          validInput = true
        }
      }
    }
    if (inputs.amountOperator && inputs.settlementAmount) {
      validInput = true
    }

    if (!validSettlementInput) {
      return setFormFeedback({ noSettlementDate: <tr ref={scrollRef}><td colSpan={2}><Alert className='custom-alert' color='danger' style={{ display: 'block', textAlign: 'center', margin: 'auto' }}>Must select a "From" or "To" Settlement Date when choosing "Total Settlement Amount Within Settlement Date Range"</Alert></td></tr> })
    }
    if (!validPaymentInput) {
      return setFormFeedback({ noPaymentDueDate: <tr ref={scrollRef}><td colSpan={2}><Alert className='custom-alert' color='danger' style={{ display: 'block', textAlign: 'center', margin: 'auto' }}>Must select a "From" or "To" Next Payment Due Date when choosing "Total Settlement Amount Within Next Payment Due Date Range"</Alert></td></tr> })
    }
    if (!validInput) {
      return setFormFeedback({ noInput: <tr ref={scrollRef}><td colSpan={2}><Alert className='custom-alert' color='danger' style={{ display: 'block', textAlign: 'center', margin: 'auto' }}>At least one input value is required</Alert></td></tr> })
    }
    setFormFeedback({})

    if (pathname === 'forcast.loss_settlement_list_report') {
      delete inputs.defenseCounsel
    } else {
      delete inputs.firmType
      delete inputs.validReopen
      delete inputs.arpcForecast
    }

    submitFormValues(pathname, navigate, inputs, pathname)
  }

  // Form components that differ are below
  let DOB = ''
  let DefenseOrClassification = ''
  let groupId = ''
  let normalized = ''
  let valid = ''
  let ARPC = ''
  let forcastTitleText = ''

  if (pathname === 'loss_settlement.loss_settlement_list_report') {
    DOB = <DateRangeInput label='DOB' name='dob' handleInputChange={handleInputChange} defaultValueFrom={inputs.dobFrom} defaultValueTo={inputs.dobTo} />
    DefenseOrClassification =
      <CustomSelectListInput label="Defense Counsel" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="outside_firm" name='defenseCounsel' multiple={true} defaultValue={inputs.defenseCounsel} />
    groupId = <TextInput label='Group ID' name='groupId' handleInputChange={handleInputChange} defaultValue={inputs.groupId} />
  } else {
    DefenseOrClassification =
      <CustomSelectListInput label="Classification" handleChange={handleInputChange} modelName="Asbestos" entityName="opp_firm_type" name='firmType' multiple={true} defaultValue={inputs.firmType} />
    normalized =
      <tr>
        <td><b>Normalized</b></td>
        <td><YesNoSelect name='normalized' handleChange={handleInputChange} defaultValue={inputs.normalized} /></td>
      </tr>
    valid =
      <tr>
        <td><b>Valid Re-open</b></td>
        <td><YesNoSelect name='validReopen' handleChange={handleInputChange} multiple={true} defaultValue={inputs.validReopen} /></td>
      </tr>
    ARPC =
      <tr>
        <td><b>Include In ARPC Forcast</b></td>
        <td><YesNoSelect name='arpcForecast' handleChange={handleInputChange} multiple={true} defaultValue={inputs.arpcForecast} /></td>
      </tr>
    forcastTitleText = 'Forcast'
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText={`${forcastTitleText} Loss Settlement List Report`} />
            {formFeedback.noInput}
            <tbody>
              <tr>
                <td><b>Plaintiff Name</b></td>
                <td>
                  <div style={{ display: 'inline-block' }}>
                    <Input className="custom-input" type='text' name='firstName' onChange={handleInputChange} defaultValue={inputs.firstName} />
                    <span><br /></span><div style={{ textAlign: 'center' }}><b>(First Name)</b></div>
                  </div>
                  <div style={{ display: 'inline-block' }}>
                    <Input className="custom-input" type='text' name='lastName' onChange={handleInputChange} defaultValue={inputs.lastName} />
                    <span><br /></span><div style={{ textAlign: 'center' }}><b>(Last Name)</b></div>
                  </div>
                </td>
              </tr>
              {DOB}
              <CustomSelectListInput label="Plaintiff Status" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="plaintiff_status" name='plaintiffStatus' multiple={true} defaultValue={inputs.plaintiffStatus} />
              <CustomSelectListInput label="Current Diagnosis" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="injury" name='currentDiagnosis' multiple={true} defaultValue={inputs.currentDiagnosis} />
              <CustomSelectListInput label="Plaintiff Counsel" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="opposing_firm" name='plaintiffCounsel' multiple={true} defaultValue={inputs.plaintiffCounsel} />
              {DefenseOrClassification}
              <CustomSelectListInput label="State" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="state" name='state' multiple={true} defaultValue={inputs.state} />
              <CustomSelectListInput label="Court Type" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="court_level" name='courtType' multiple={true} defaultValue={inputs.courtType} />
              <CustomSelectListInput label="Exposure" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="exposure_type" name='exposureType' multiple={true} defaultValue={inputs.exposureType} />
              {groupId}
              <DateRangeInput label='Date Assigned' name='dateAssigned' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateAssignedFrom} defaultValueTo={inputs.dateAssignedTo} />
              <DateRangeInput label='Date Closed' name='dateClosed' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateClosedFrom} defaultValueTo={inputs.dateClosedTo} />
              {formFeedback.noSettlementDate}
              <DateRangeInput label='Settlement Date' name='settlementDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.settlementDateFrom} defaultValueTo={inputs.settlementDateTo} />
              {formFeedback.noPaymentDueDate}
              <DateRangeInput label='Next Payment Due Date' name='nextPaymentDueDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.nextPaymentDueDateFrom} defaultValueTo={inputs.nextPaymentDueDateTo} />
              <DateRangeInput label='Date Re-Opened' name='dateReopened' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateReopenedFrom} defaultValueTo={inputs.dateReopenedTo} />
              <DateRangeInput label='Date Re-Closed' name='DateReclosed' handleInputChange={handleInputChange} defaultValueFrom={inputs.DateReclosedFrom} defaultValueTo={inputs.DateReclosedTo} />
              <DateRangeInput label='Date Moved To Pending' name='dateMovedToPending' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateMovedToPendingFrom} defaultValueTo={inputs.dateMovedToPendingTo} />
              <DateRangeInput label='Date Moved to Abandoned' name='dateMovedToAbandoned' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateMovedToAbandonedFrom} defaultValueTo={inputs.dateMovedToAbandonedTo} />
              <DateRangeInput label='Date Moved to Inactive' name='dateMovedToInactive' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateMovedToInactiveFrom} defaultValueTo={inputs.dateMovedToInactiveTo} />
              <DateRangeInput label='Date Moved from Abandoned to Open or Pending' name='dateMovedToOpen' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateMovedToOpenFrom} defaultValueTo={inputs.dateMovedToOpenTo} />
              <tr>
                <td style={{ whiteSpace: 'nowrap' }}><b>Date Moved from Abandoned to Closed or Inactive</b></td>
                <td>
                  <b>From</b><Input className="custom-input" type='date' name='dateMovedToClosedFrom' onChange={handleInputChange} defaultValue={inputs.dateMovedToClosedFrom} />
                  <b>To</b><Input className="custom-input" type='date' name='dateMovedToClosedTo' onChange={handleInputChange} defaultValue={inputs.dateMovedToClosedTo} />
                </td>
              </tr>
              <DateRangeInput label='Date Moved from Inactive' name='dateMovedFromInactive' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateMovedFromInactiveFrom} defaultValueTo={inputs.dateMovedFromInactiveTo} />
              <tr>
                <td><b>Settlement Amount</b></td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <Input
                    type="select"
                    name="amountOperator"
                    onChange={handleInputChange}
                    style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}
                    defaultValue={inputs.amountOperator}
                  >
                    <option value={''}>Select Condition</option>
                    <option value={'<'}>Less Than &emsp;{'(<)'}</option>
                    <option value={'='}>Equal To &emsp;{'(=)'}</option>
                    <option value={'>'}>Greater Than &emsp;{'(>)'}</option>
                  </Input> &emsp;
                  <b>$</b><Input className="custom-input" type='number' onKeyDown={(e) => e.key === 'e' && e.preventDefault()} name='settlementAmount' onChange={handleInputChange} defaultValue={inputs.settlementAmount} />
                  <Input className="custom-checkbox" type="checkbox" name="includeBlankSettlementAmounts" onChange={handleInputChange} defaultChecked={inputs.includeBlankSettlementAmounts} /> <b>Include Blank Settlement Amounts</b> <span><br /></span>
                  <Input
                    type="select"
                    name="settlementType"
                    onChange={handleInputChange}
                    style={{ width: 'auto', display: 'inline-block', marginRight: '5px', marginTop: '5px' }}
                    defaultValue={inputs.settlementType}
                  >
                    <option value={1}>Total Settlement Amount For Claim</option>
                    <option value={2}>Most Recent Settlement Amount</option>
                    <option value={3}>Total Settlement Amount Within Settlement Date Range</option>
                    <option value={4}>Total Settlement Amount Within Next Payment Due Date Range</option>
                  </Input>
                </td>
              </tr>
              <tr>
                <td><b>Check Number</b></td>
                <td>
                  <Input className="custom-input" type='text' name='checkNumber' onChange={handleInputChange} defaultValue={inputs.checkNumber} />
                  <span><br /></span><b>(Type "NULL" if specifically searching for records where there is no check number)</b>
                </td>
              </tr>
              {normalized}
              <tr>
                <td><b>Document ID's</b></td>
                <td>
                  <Input className="custom-input" type='text' name='documentId' onChange={handleInputChange} defaultValue={inputs.documentId} />
                  <span><br /></span><b>(Note: Multiple document ID's should be separated by a comma, no quotes)</b>
                </td>
              </tr>
              <tr>
                <td><b>Sort By</b></td>
                <td> <Input
                  className="custom-input"
                  type="select"
                  name="sortBy"
                  onChange={handleInputChange}
                  style={{ width: 'auto' }}
                  defaultValue={inputs.sortBy}
                >
                  <option value={'BY_PLAINTIFF_LAST_NAME'}>Plaintiff Last Name</option>
                  <option value={'BY_DIAGNOSIS'}>Current Diagnosis</option>
                </Input></td>
              </tr>
              {valid}
              {ARPC}
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label='Run Report' />
      </form>
    </div>
  )
}
